import axios from './axios';
import utils from '../libs/utils';


const protocol = window.location.protocol;
const insuranceUrl = `${protocol}//medical.erp.dtp.linkdoc.com:9999`;

export default {
  axios,
  readCard(params) { // 北京医保读卡
    return axios.post(`${insuranceUrl}/medical/bj/readCard`, utils.exchangeParams(params));
  },
  divideDrugstore(params) { // 北京医保预结算
    return axios.post(`${insuranceUrl}/medical/bj/divideDrugstore`, utils.exchangeParams(params));
  },
  tradeDrugstore(params) { // 北京医保结算
    return axios.post(`${insuranceUrl}/medical/bj/tradeDrugstore`, utils.exchangeParams(params));
  },
  getExRxInfo() { // 北京医保获取外配处方信息
    return axios.post(`${insuranceUrl}/medical/bj/getExRxInfo`);
  },
  refundmentDivideDrugstore(params) { // 北京医保退费，即撤销结算
    return axios.post(`${insuranceUrl}/medical/bj/refundmentDivideDrugstore`, utils.exchangeParams(params));
  },
  refundmentTradeDrugstore(params) { // 北京医保退费
    return axios.post(`${insuranceUrl}/medical/bj/refundmentTradeDrugstore`, utils.exchangeParams(params));
  },
  printInvocie(params) { // 北京医保收据打印
    return axios.post(`${insuranceUrl}/medical/bj/printInvocie`, utils.exchangeParams(params));
  },
};
